var map = {
	"./template.bet575": 1653,
	"./template.bet575.tsx": 1653,
	"./template.bet777": 2086,
	"./template.bet777.tsx": 2086,
	"./template.betbetbet": 2087,
	"./template.betbetbet.tsx": 2087,
	"./template.betblast": 1654,
	"./template.betblast.tsx": 1654,
	"./template.betgalaxy": 2088,
	"./template.betgalaxy.tsx": 2088,
	"./template.betprofessor": 2001,
	"./template.betprofessor.tsx": 2001,
	"./template.betroyale": 2089,
	"./template.betroyale.tsx": 2089,
	"./template.betstride": 2090,
	"./template.betstride.tsx": 2090,
	"./template.buffalobet": 2091,
	"./template.buffalobet.tsx": 2091,
	"./template.chromabet": 2092,
	"./template.chromabet.tsx": 2092,
	"./template.default": 674,
	"./template.default.tsx": 674,
	"./template.fiestabet": 2002,
	"./template.fiestabet.tsx": 2002,
	"./template.forsport": 1655,
	"./template.forsport.tsx": 1655,
	"./template.gigabet": 2093,
	"./template.gigabet.tsx": 2093,
	"./template.goldenbet888": 1656,
	"./template.goldenbet888.tsx": 1656,
	"./template.goldenrush": 2094,
	"./template.goldenrush.tsx": 2094,
	"./template.hyperbet": 2095,
	"./template.hyperbet.tsx": 2095,
	"./template.juicybet": 1657,
	"./template.juicybet.tsx": 1657,
	"./template.junglebet": 1658,
	"./template.junglebet.tsx": 1658,
	"./template.magnumbet": 2096,
	"./template.magnumbet.tsx": 2096,
	"./template.oldgill": 1659,
	"./template.oldgill.tsx": 1659,
	"./template.puntcity": 1660,
	"./template.puntcity.tsx": 1660,
	"./template.puntgenie": 2097,
	"./template.puntgenie.tsx": 2097,
	"./template.pyramidbet": 2098,
	"./template.pyramidbet.tsx": 2098,
	"./template.questbet": 1661,
	"./template.questbet.tsx": 1661,
	"./template.slambet": 2003,
	"./template.slambet.tsx": 2003,
	"./template.sterlingparker": 2004,
	"./template.sterlingparker.tsx": 2004,
	"./template.sugarcastle": 2099,
	"./template.sugarcastle.tsx": 2099,
	"./template.templebet": 2100,
	"./template.templebet.tsx": 2100,
	"./template.titanbet": 2101,
	"./template.titanbet.tsx": 2101,
	"./template.ts": 89,
	"./template.vikingbet": 1662,
	"./template.vikingbet.tsx": 1662,
	"./template.volcanobet": 2102,
	"./template.volcanobet.tsx": 2102,
	"./template.wellbet": 1663,
	"./template.wellbet.tsx": 1663
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2462;